/* eslint-disable */
import { TScrollHolder } from '../types';

export const defaultScrollHolder: TScrollHolder = {
  isScrollBottom: () => false,
  scrollBottom: (smooth: boolean) => undefined,
};
